import { render, staticRenderFns } from "./demoProlipa.vue?vue&type=template&id=07c2872a&scoped=true"
import script from "./demoProlipa.vue?vue&type=script&lang=js"
export * from "./demoProlipa.vue?vue&type=script&lang=js"
import style0 from "./demoProlipa.vue?vue&type=style&index=0&id=07c2872a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c2872a",
  null
  
)

export default component.exports